const rankingItems = [
  { rank: 1, title: '长安十二时辰', type: '电视剧', hot: '9.8', desc: '古装悬疑口碑神作' },
  { rank: 2, title: '流浪地球3', type: '电影', hot: '9.7', desc: '国产科幻票房冠军' },
  { rank: 3, title: '乘风破浪的姐姐', type: '综艺', hot: '9.6', desc: '现象级唱跳竞演' },
  { rank: 4, title: '鬼灭之刃 无限城篇', type: '动漫', hot: '9.5', desc: '日漫年度霸权新番' },
  { rank: 5, title: '狂飙', type: '电视剧', hot: '9.4', desc: '扫黑除恶经典之作' },
  { rank: 6, title: '奥本海默', type: '电影', hot: '9.3', desc: '诺兰导演传记巨制' },
  { rank: 7, title: '斗破苍穹 年番', type: '动漫', hot: '9.2', desc: '国漫顶级制作水准' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">热播榜单</h2>
            <p className="text-sm text-gray-500 mt-2">本周最受欢迎的热门内容排行</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
              {rankingItems.map((item, idx) => (
                <div
                  key={idx}
                  className={`flex items-center gap-4 px-5 py-4 ${
                    idx < rankingItems.length - 1 ? 'border-b border-gray-50' : ''
                  } hover:bg-gray-50 transition-colors duration-200 cursor-pointer`}
                >
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                    item.rank === 1 ? 'bg-warm-500 text-white' :
                    item.rank === 2 ? 'bg-gray-400 text-white' :
                    item.rank === 3 ? 'bg-warm-300 text-white' :
                    'bg-gray-100 text-gray-500'
                  }`}>
                    <span className="text-sm font-bold">{item.rank}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-gray-900 truncate">{item.title}</h3>
                    <p className="text-xs text-gray-400 mt-0.5">{item.desc}</p>
                  </div>
                  <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded whitespace-nowrap">{item.type}</span>
                  <span className="text-sm font-bold text-warm-600 whitespace-nowrap w-10 text-right">{item.hot}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}